import msgImg from '../../assets/message.jpg'
import gbsImg from '../../assets/gbs.jpg'
import symImg from '../../assets/symposium.jpg'
import choirImg from '../../assets/choir.jpg'


const resources = [
    {
        id: 1,
        img: msgImg,
        text: "Message",
        file_download: [
            {
                id:1,
                day: "Day 1",
                link: "https://drive.google.com/drive/folders/11CnNlQzIiHq6Fv6d3pyqFKPrHKd4aUoT?usp=sharing"
            },
            {
                id:2,
                day: "Day 2",
                link: "https://drive.google.com/drive/folders/11CnNlQzIiHq6Fv6d3pyqFKPrHKd4aUoT?usp=sharing"
            }
        ]
    },
    {
        id: 2,
        img: gbsImg,
        text: "Group Bible Study",
        file_download: [
            {
                id:1,
                day: "Make Disciples of All Nations",
                link: "https://docs.google.com/document/d/1iea4X6vpSd7IjQpKRB6k6015SfHugB6OmIsrURUZDUw/edit?usp=sharing"
            },
            {
                id:2,
                day: "Seek First His Kingdom",
                link: "https://docs.google.com/document/d/1hpsDxj-YRlVfLRWe7NbgClpQc7kyQXinuj0A_lE3Y_I/edit?usp=sharing"
            }
           
        ]
    },
    {
        id: 3,
        img: symImg,
        text: "Symposium",
        file_download: [
            {
                id:1,
                day: "Day 1",
                link: "https://drive.google.com/drive/folders/11CnNlQzIiHq6Fv6d3pyqFKPrHKd4aUoT?usp=sharing"
            },
            {
                id:2,
                day: "Day 2",
                link: "https://drive.google.com/drive/folders/11CnNlQzIiHq6Fv6d3pyqFKPrHKd4aUoT?usp=sharing"
            }
        ]
    },
    {
        id: 4,
        img: choirImg,
        text: "Choir Ministration",
        file_download: [
            {
                id:1,
                day: "Day 1",
                link: "https://drive.google.com/drive/folders/11CnNlQzIiHq6Fv6d3pyqFKPrHKd4aUoT?usp=sharing"
            },
            {
                id:2,
                day: "Day 2",
                link: "https://drive.google.com/drive/folders/11CnNlQzIiHq6Fv6d3pyqFKPrHKd4aUoT?usp=sharing"
            }
            // {
            //     text_files: [
                  
            //     ]
            // },
            // {
            //     audio_files: [
                   
            //     ]
            // }
        ]
    }
]

export default resources